import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formatAdminDateTime } from "./date";

export function exportResultsToCSV(results, questions, filename) {
  if (!results.length) return;

  const questionHeaders = questions.map((q, i) => q.en?.question || `Question ${i + 1}`);
  const headers = [
    "Full Name", "Phone", "Alt Phone", "Address", "Aadhar", "DOB", "Gender",
    "Education", "Medical Exp", "Total Exp", "Prev Company",
    "Current Salary", "Expected Salary", "Availability",
    "Score", "Total Questions", "Time Taken (s)", "Typing WPM", "Typing Accuracy", "Typing Chars", "Date", "Language",
    ...questionHeaders,
  ];

  const rows = results.map((res) => {
    const baseData = [
      res.candidate.fullName,
      res.candidate.phoneNumber,
      res.candidate.altPhoneNumber,
      res.candidate.currentAddress,
      res.candidate.aadharNumber,
      res.candidate.dob,
      res.candidate.gender,
      res.candidate.education,
      res.candidate.medicalExp,
      res.candidate.totalExp || "N/A",
      res.candidate.prevCompany || "N/A",
      res.candidate.currentSalary || "N/A",
      res.candidate.expectedSalary,
      res.candidate.availability,
      res.score,
      res.total,
      res.timeTakenSeconds || 0,
      res.typingTest?.wpm ?? "",
      res.typingTest?.accuracy ?? "",
      res.typingTest?.totalChars ?? "",
      formatAdminDateTime(res.timestamp),
      res.lang,
    ];

    for (let i = 0; i < res.answers?.length || 0; i += 1) {
      baseData.push((res.answers && res.answers[i]) || "N/A");
    }

    return baseData;
  });

  const csvContent = [
    headers.join(","),
    ...rows.map((row) => row.map((cell) => `"${(cell || "").toString().replace(/"/g, '""')}"`).join(",")),
  ].join("\n");

  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename || `hevmed_results_${new Date().toISOString().split("T")[0]}.csv`);
  link.click();
  URL.revokeObjectURL(url);
}

export function exportResultsToPDF(results, filename) {
  if (!results.length) return;

  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(16);
  doc.text("HevMed Interview Results", 14, 15);

  const tableData = results.map((res) => [
    res.candidate.fullName,
    res.candidate.phoneNumber,
    `${res.score}/${res.total}`,
    res.typingTest?.wpm ?? "—",
    res.candidate.medicalExp,
    formatAdminDateTime(res.timestamp),
    res.lang,
  ]);

  autoTable(doc, {
    startY: 22,
    head: [["Name", "Phone", "Score", "WPM", "Experience", "Date", "Language"]],
    body: tableData,
    styles: { fontSize: 9 },
    headStyles: { fillColor: [13, 148, 136] },
  });

  doc.save(filename || `hevmed_results_${new Date().toISOString().split("T")[0]}.pdf`);
}
